module.exports = __webpack_public_path__ + "img/logo.e97f4cad.png";